module.exports = __webpack_public_path__ + "img/print-maker-1024.b3652e54.jpg";